import axios from "axios";
import config from '../constants/config';
import LocalStorage from "../components/LocalStorage";

//Create a instance
const apiUrl = (config.environment === 'production') ? config.production.api_url : config.development.api_url;
const instance = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    }
});

//Set AUTH token for any request
instance.interceptors.request.use(function (config) {
    const token = LocalStorage.getAccessToken();
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    return config;
});

// Auto-logout on an expired/invalid session: a 401 from any authenticated owner call clears the
// stored token and hard-redirects to /login. Excludes the auth endpoints themselves (a 401 there
// is a normal "invalid credentials", handled by the form) and skips redirecting if already on the
// login page, so there is no redirect loop.
instance.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const url = error?.config?.url || '';
        const isAuthCall = /venues\/(login|register|forgot-password|reset-password)/.test(url) || /staff\/(login|list-for-login)/.test(url);
        const onLoginPage = ['/login', '/staff-login'].includes(window.location.pathname);
        if (status === 401 && !isAuthCall && !onLoginPage) {
            LocalStorage.logout();
            window.location.replace('/login?expired=1');
        }
        return Promise.reject(error);
    }
);

const doAPI = {
    //Get data from the server by method = GET
    getData: (URL, parameters = {}) =>
        instance({
            'method': 'GET',
            'url': URL,
            'params': parameters
        }),
    //Post JSON Object on the server by method = POST
    postData: (URL, parameters = {}) =>
        instance({
            'method': 'POST',
            'url': URL,
            'data': parameters
        }),
    //Post FormData (multipart, with image) on the server by method = POST.
    //Uses the shared `instance` so the auth-token request interceptor and the 401 auto-logout
    //response interceptor apply to uploads too (raw axios.post would bypass both).
    postWithImage: (url, body, callback) =>
        instance.post(url, createFormData(body), {
            headers: { 'Content-Type': 'multipart/form-data' },
            transformRequest: formData => formData,
            onUploadProgress: callback,
        }),
    //Post JSON Object on the server by method = PUT
    putData: (URL, parameters = {}) =>
        instance({
            'method': 'PUT',
            'url': URL,
            'data': parameters
        }),
    //Delete a resource by method = DELETE
    deleteData: (URL) =>
        instance({
            'method': 'DELETE',
            'url': URL,
        }),
};

/**
 * Helper function to create a from data
 * @param {*} body 
 * @returns 
 */
const createFormData = (body) => {
    const data = new FormData();
    Object.keys(body).forEach(key => {
        data.append(key, body[key]);
    });
    return data;
};

export default doAPI;